import { useTranslation } from "react-i18next";

export default function CTASection() {
  const { t } = useTranslation();

  return (
    <section className="flex flex-col lg:flex-row min-h-[480px] md:min-h-[540px]">
      <div className="lg:w-1/2 relative overflow-hidden min-h-[300px] lg:min-h-full">
        <img
          src="https://readdy.ai/api/search-image?query=Clean%20bright%20modern%20workspace%20with%20open%20laptop%20on%20wooden%20desk%20displaying%20colorful%20organized%20spreadsheet%20data%2C%20warm%20natural%20sunlight%20streaming%20through%20large%20window%2C%20terracotta%20mug%20and%20small%20succulent%20plant%20on%20desk%2C%20editorial%20productivity%20photography%2C%20calm%20focused%20atmosphere%2C%20minimal%20home%20office%20aesthetic&width=1200&height=900&seq=cta-left-v2-2026&orientation=landscape"
          alt="OOPBUY Spreadsheet workspace"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/15"></div>
        <div className="absolute bottom-8 left-8">
          <span className="text-xs font-medium text-background-100/80 tracking-wider uppercase">
            {t("hero.badge")}
          </span>
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-background-50 mt-2 leading-[1.1]">
            Get
            <br />
            The
            <br />
            OOPBUY Tool
          </h2>
        </div>
      </div>

      <div className="lg:w-1/2 bg-background-50 flex items-center justify-center px-6 py-14 md:py-20">
        <div className="max-w-md text-center">
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground-950 leading-[1.15] mb-6">
            {t("cta.title_line1")}
            <br />
            {t("cta.title_line2")}
          </h2>
          <p className="text-base md:text-lg text-foreground-600 leading-relaxed mb-8">
            {t("cta.description")}
          </p>
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-foreground-950 text-background-50 text-sm md:text-base font-semibold cursor-pointer whitespace-nowrap hover:bg-foreground-800 transition-colors"
          >
            {t("cta.button")}
          </a>
        </div>
      </div>
    </section>
  );
}